var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('static-content-wrapper', {
    attrs: {
      "designer": _vm.designer,
      "field": _vm.field,
      "design-state": _vm.designState,
      "display-style": _vm.field.options.displayStyle,
      "parent-widget": _vm.parentWidget,
      "parent-list": _vm.parentList,
      "index-of-parent-list": _vm.indexOfParentList,
      "sub-form-row-index": _vm.subFormRowIndex,
      "sub-form-col-index": _vm.subFormColIndex,
      "sub-form-row-id": _vm.subFormRowId
    }
  }, [_c('el-button', {
    ref: "fieldEditor",
    class: [(_vm.field.options.label === '') ? 'hide-text-span' : ''],
    attrs: {
      "type": _vm.field.options.type,
      "size": _vm.field.options.size,
      "plain": _vm.field.options.plain,
      "round": _vm.field.options.round,
      "circle": _vm.field.options.circle,
      "icon": _vm.field.options.icon,
      "disabled": _vm.field.options.disabled
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleButtonWidgetClick.apply(null, arguments)
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.field.options.label))])], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23b8e371","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-designer/form-widget/field-widget/button-widget.vue
// module id = null
// module chunks = 